import type { TFunction } from 'i18next';

/**
 * Maps a failed login (RTK Query error) to a message that tells the visitor what actually
 * happened - wrong credentials, rate limit, server or connection problem - instead of
 * always claiming the password was wrong.
 */
export const getLoginErrorMessage = (error: any, t: TFunction): string => {
  const status = error?.status;

  if (status === 'FETCH_ERROR' || status === 'TIMEOUT_ERROR' || (typeof navigator !== 'undefined' && !navigator.onLine)) {
    return t('login.networkError');
  }

  if (status === 429) {
    return t('login.tooManyAttempts');
  }

  if (status === 'PARSING_ERROR' || (typeof status === 'number' && status >= 500)) {
    return t('login.serverError');
  }

  return t('login.invalidCredentials');
};

/** Accepts only same-site absolute paths ("/cart"), never "//evil.com" or full URLs. */
export const getSafeReturnPath = (returnTo: string | null): string | null =>
  returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//') && !returnTo.includes('\\')
    ? returnTo
    : null;
